import {AppDocumentType} from "../../types/AppDocumentType";

export const LOGISTICS_DRIVER_CHANGE_LOG_COLLECTION = "logisticsDriverChangeLog";
export const LOGISTICS_CHANGE_LOG_COLLECTION = LOGISTICS_DRIVER_CHANGE_LOG_COLLECTION;

export type LogisticsChangeLogType =
    "DRIVER"
    | "TRUCK"
    | "PLAN_START_DATE"
    | "PLAN_END_DATE"
    | "ROUTE"
    | "EVENT_NUMBER"
    | "DAY_TYPE"
    | "REPORT_START_DATE"
    | "REPORT_END_DATE"
    | "START_KM"
    | "END_KM"
    | "REPORT_NOTES"
    | "DELETE";

export type LogisticsDriverChangeLogType = AppDocumentType & {
    changeType: LogisticsChangeLogType;
    logisticId: string;
    eventNumber: string;
    periodStart: Date | null;
    periodEnd: Date | null;
    previousValue: string;
    newValue: string;
    changedAt: Date;
    changedByEmployeeId: string | null;
    changedByName: string;
};
